module.exports = [{"award":"Summer of Tech Hackfest Best Project","date":"2014","desc":"StylishWeather web application"},{"award":"Finalist for IMC Strategy Prize","date":"2013","desc":"Strategic analysis and infographics of an Ireland snack company, Tayto"},{"award":"Corbelletti Design Charrette","date":"2008","desc":"from Pennsylvania State University"},{"award":"Certificate of Excellence Academic Achievement Award","date":"2008","desc":"from Pennsylvania State University"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/achievements.json
// module id = 35
// module chunks = 0